import { render } from "./index.vue?vue&type=template&id=ee204ea4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "@/assets/scss/how-to-play/how-to-play.scss?vue&type=style&index=0&id=ee204ea4&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee204ea4"]])

export default __exports__